import { Tab, Tabs } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import ApplicationsAndQuotesTable from "./ApplicationsAndQuotesTable"
import RenewalsAndContactInfoTable from "./RenewalsAndContactInfoTable"
import "bootstrap/dist/css/bootstrap.min.css"
import { Container, Row, Col, Card } from "react-bootstrap"
import { useSelector } from "react-redux"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { getNotifications } from "../../../data/notificationSlice"
import { css } from "@emotion/react"
import HelpCenterCard from "../../../components/HelpCenterCard"
import NotificationsCard from "../../../components/NotificationsCard"

const componentStyles = css`
    margin-top: 80px;
`

const Dashboard = () => {
    const dispatch = useDispatch()
    const { data } = useSelector((state) => state.notification)

    useEffect(() => {
        !data?.length && dispatch(getNotifications())
    }, [])

    return (
        <div
            className="page-container gai-tabs"
            css={componentStyles}>
            <Container
                fluid
                className="d-flex flex-row justify-content-center">
                <Row>
                    <Col
                        md={6}
                        className="d-flex align-items-stretch">
                        <NotificationsCard data={data} />
                    </Col>
                    <Col
                        md={6}
                        className="d-flex align-items-stretch">
                        <HelpCenterCard />
                    </Col>
                </Row>
            </Container>

            <Tabs
                defaultActiveKey="applications-quotes"
                id="uncontrolled-tab-example"
                className="mt-4">
                <Tab
                    eventKey="applications-quotes"
                    title=" Applications and Quotes">
                    <ApplicationsAndQuotesTable />
                </Tab>
                {/* <Tab
                    eventKey="binders-policies"
                    title="Binders and Policies">
                    <BindersAndPoliciesTable />
                </Tab> */}
                <Tab
                    eventKey="Renewals-contact-info"
                    title="Renewals and Contact Info">
                    <RenewalsAndContactInfoTable />
                </Tab>
            </Tabs>
        </div>
    )
}

export default Dashboard
